/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { AmountEuroCents } from "./AmountEuroCents";
import * as t from "io-ts";
import { PatternString } from "@pagopa/ts-commons/lib/strings";

/**
 * The dto that contains information about the creditor entities
 */

// required attributes
const TransferR = t.interface({
  paFiscalCode: PatternString("^[a-zA-Z0-9]{11}"),

  digitalStamp: t.boolean,

  transferAmount: AmountEuroCents
});

// optional attributes
const TransferO = t.partial({
  transferCategory: t.string
});

export const Transfer = t.intersection([TransferR, TransferO], "Transfer");

export type Transfer = t.TypeOf<typeof Transfer>;
